export default __webpack_public_path__ + "static/media/BackupValidataionStatus02-PostgreSQL.355b132a.png";